import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import { chain, includes } from 'lodash'
import Loader from 'react-loader'
import {SlideDown} from 'react-slidedown'
import {Row, Col} from 'react-flexbox-grid'
import config from '../../config'
import {
  CompanyProfileModal,
  Link,
  LinkIcon
} from '../'
import * as searchActions from 'redux/modules/search'
import Styles from './ScreenedCompanies.css'


@connect(
  state => ({
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  }),
  searchActions)
@CSSModules(Styles, {allowMultiple:true})
export default class ScreenedCompanies extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }
  constructor(props){
    super(props)
    this.state = {
      // viewMoreProducers: false,
      // viewMoreFinanciers: false,
      // viewMoreConsumers: false,
      //
      showList: 'none',
    }
  }

  componentWillMount() {
    /**
     * On page load, scroll to top, call API for list of companies.
     */
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.props.companies()
  }

  componentWillReceiveProps(props){
    /**
     * Sort list of companies from API into three lists, then sort by name.
     */
    if (props.result) {
      const companies = {
        p: [],
        f: [],
        c: [],
      }

      props.result.forEach(item => {
        if (item.is_po_producer) companies.p.push(item)
        if (item.is_po_financier) companies.f.push(item)
        if (item.is_po_consumer) companies.c.push(item)
      })

      const _sorter = (a, b) => {
        const _a = a.short_name.toLowerCase()
        const _b = b.short_name.toLowerCase()
        return _a.localeCompare(_b)
      }

      ['p','f','c'].forEach(c => {
        companies[c] = companies[c].sort(_sorter)
      })

      this.setState({
        companies,
      })
    }
  }

  clickShowList = (sectorCode) => {
    /**
     * Update state to show only one list at a time.
     */
    const newState = {}
    if (this.state.showList === sectorCode) {
      newState.showList = 'none'
    } else {
      newState.showList = sectorCode
    }
    this.setState(newState)
  }

  render() {
    if (!this.props.result) {
      return <div styleName="main">
        <Loader
          options={{scale: 0.70, top:'4.0rem'}}
          loaded={ false }
        />
      </div>
    }

    // card configs
    const cardIcons = {
      p: require( '../../../static/images/icn-producers.svg' ),
      f: require( '../../../static/images/icn-banks.svg' ),
      c: require( '../../../static/images/icn-consumers.svg' ),
    }

    const cardTitles = {
      p: 'Agricultural commodity producers and traders',
      f: 'Banks and lenders',
      c: 'Major consumer brands',
    }

    const cardText = {
      p: (
        <span>
          Companies that produce and trade palm oil, paper/pulp, rubber,
          timber, cattle, and soy, and have a past record or a significant
          risk of contributing to deforestation, land grabbing, and human
          rights abuses.
        </span>
      ),
      f: (
        <span>
          Financial institutions directly and indirectly involved in
          underwriting and lending to deforestation-risk producers and
          traders. These are the publicly listed banks drawn from the
          platform <Link
            to={config.links.fAndf}
            title='Forests & Finance'
            xstrong
          >Forests & Finance</Link>.
        </span>
      ),
      c: (
        <span>
          Consumer goods retailers that source palm oil, paper/pulp,
          rubber, timber, cattle, and soy from deforestation-risk producers
          and traders and sell it to consumers worldwide.
        </span>
      ),
    }

    //
    return <section styleName='screened-companies'>
      <div styleName='screened-companies__cards'>
        { /* Render three cards as columns */
          ['p','f','c'].map(sectorCode => {
            return <div styleName='screened-companies__card'>
              <div styleName='screened-companies__card-content'>
                <img
                  styleName='screened-companies__card-icon'
                  src={ cardIcons[sectorCode] }
                  alt='Agricultural commodity producers and traders'
                />
                <h2 styleName='screened-companies__card-title'>
                  { cardTitles[sectorCode] }
                </h2>
                <p styleName='screened-companies__card-text'>
                  { cardText[sectorCode] }
                </p>
                <button
                  styleName='screened-companies__card-btn'
                  onClick={
                    ()=>{ this.clickShowList(sectorCode) }
                  }
                  title='See companies'
                >
                  See companies
                  <LinkIcon
                    faclass={
                      this.state.showList === sectorCode ?
                        'fa-angle-up' :
                        'fa-angle-down'
                      }
                  />
                </button>
              </div>

              <div styleName='hidden-md hidden-lg'>
                <SlideDown>
                  {
                    this.state.showList === sectorCode ?
                      <ScreenedCompaniesList
                        sectorCode={sectorCode}
                        sectorTitle={cardTitles[sectorCode]}
                        companies={this.state.companies[sectorCode]}
                      /> :
                      null
                  }
                </SlideDown>
              </div>
            </div>
          })
        }
      </div>

      <div styleName='hidden-xs hidden-sm'>
        {
          ['p','f','c'].map(sectorCode => {
            return <SlideDown>
              {
                this.state.showList === sectorCode ?
                  <ScreenedCompaniesList
                    sectorCode={sectorCode}
                    sectorTitle={cardTitles[sectorCode]}
                    companies={this.state.companies[sectorCode]}
                  /> :
                  null
              }
            </SlideDown>
          })
        }
      </div>

    </section>
  }
}


@CSSModules(Styles, {allowMultiple:true})
class ScreenedCompaniesList extends Component {
  static propTypes = {
    companies: PropTypes.array,
    sectorCode: PropTypes.string,
    sectorTitle: PropTypes.string,
  }
  constructor(props){
    super(props)
    this.state = {}
  }

  getCompanyFlags = (company, icons) => {
    /**
     * Each flags list is a list of lists.
     * Each item in a flags list is a list of three elements.
     * The three elements are the flag code, e.g. is_sy_p,
     * the flag icon, e.g. icons.iconSy,
     * and the flag label, e.g. 'Soy producer'
     * ['is_sy_p', icons.iconSy, 'Soy producer']
     */
    // Get sectors from CompanySectors.json
    const c = config.companySectors.data[company.company_id]
    let flags = []

    // Three types of links possible
    if (this.props.sectorCode === 'p') {
      if (includes(c, 'is_sy_p')){ flags.push(['is_sy_p', icons.iconSy, 'Soy producer']) }
      if (includes(c, 'is_bf_p')){ flags.push(['is_bf_p', icons.iconBf, 'Cattle producer']) }
      if (includes(c, 'is_tb_p')){ flags.push(['is_tb_p', icons.iconTb, 'Timber producer']) }
      if (includes(c, 'is_rb_p')){ flags.push(['is_rb_p', icons.iconRb, 'Rubber producer']) }
      if (includes(c, 'is_pp_p')){ flags.push(['is_pp_p', icons.iconPp, 'Paper/pulp producer']) }
      if (includes(c, 'is_po_p')){ flags.push(['is_po_p', icons.iconPo, 'Palm oil producer']) }
    }

    if (this.props.sectorCode === 'f') {
      flags = [
        ['is_sy_c', icons.iconSyO, 'Soy financier'],
        ['is_bf_c', icons.iconBfO, 'Cattle financier'],
        ['is_tb_c', icons.iconTbO, 'Timber financier'],
        ['is_rb_c', icons.iconRbO, 'Rubber financier'],
        ['is_pp_c', icons.iconPpO, 'Paper/pulp financier'],
        ['is_po_c', icons.iconPoO, 'Palm oil financier']
      ]
    }

    if (this.props.sectorCode === 'c') {
      if (includes(c, 'is_sy_c')){ flags.push(['is_sy_c', icons.iconSyY, 'Soy major consumer brand']) }
      if (includes(c, 'is_bf_c')){ flags.push(['is_bf_c', icons.iconBfY, 'Cattle major consumer brand']) }
      if (includes(c, 'is_tb_c')){ flags.push(['is_tb_c', icons.iconTbY, 'Timber major consumer brand']) }
      if (includes(c, 'is_rb_c')){ flags.push(['is_rb_c', icons.iconRbY, 'Rubber major consumer brand']) }
      if (includes(c, 'is_pp_c')){ flags.push(['is_pp_c', icons.iconPpY, 'Paper/pulp major consumer brand']) }
      if (includes(c, 'is_po_c')){ flags.push(['is_po_c', icons.iconPoY, 'Palm oil major consumer brand']) }
    }

    return flags
  }

  getCompanyLinks = (company) => {
    /**
     * See CompanyLinks.json for shape of links objects.
     */
    // Get links from CompanyLinks.json
    const links = config.companyLinks.data[company.company_id]

    // Six types of links possible
    const zsl_spott = links ? links.zsl_spott : ''
    const supply_change = links ? links.supply_change : ''
    const banktrack = links ? links.banktrack : ''
    const rspo = links ? links.rspo : ''
    const forest500 = links ? links.forest500 : ''
    const other_link = links ? links.other_link : ''

    return [
      [zsl_spott, 'ZSL SPOTT'],
      [supply_change, 'Supply Change'],
      [banktrack, 'BankTrack'],
      [rspo, 'RSPO'],
      [forest500, 'Forest500'],
      [other_link, 'Other']
    ]
  }

  //
  render() {
    const icons = {
      iconPo: require( '../../../static/images/icn-po.svg' ),
      iconPp: require( '../../../static/images/icn-pp.svg' ),
      iconRb: require( '../../../static/images/icn-rb.svg' ),
      iconTb: require( '../../../static/images/icn-tb.svg' ),
      iconBf: require( '../../../static/images/icn-bf.svg' ),
      iconSy: require( '../../../static/images/icn-sy.svg' ),
      iconPoO: require( '../../../static/images/icn-po-o.svg' ),
      iconPpO: require( '../../../static/images/icn-pp-o.svg' ),
      iconRbO: require( '../../../static/images/icn-rb-o.svg' ),
      iconTbO: require( '../../../static/images/icn-tb-o.svg' ),
      iconBfO: require( '../../../static/images/icn-bf-o.svg' ),
      iconSyO: require( '../../../static/images/icn-sy-o.svg' ),
      iconPoY: require( '../../../static/images/icn-po-y.svg' ),
      iconPpY: require( '../../../static/images/icn-pp-y.svg' ),
      iconRbY: require( '../../../static/images/icn-rb-y.svg' ),
      iconTbY: require( '../../../static/images/icn-tb-y.svg' ),
      iconBfY: require( '../../../static/images/icn-bf-y.svg' ),
      iconSyY: require( '../../../static/images/icn-sy-y.svg' ),
    }

    //
    return <div styleName='screened-companies-list'>
      <h2 styleName='screened-companies-list__title'>
        { this.props.sectorTitle }
      </h2>
      <table styleName='screened-companies-list__table'>
        <thead>
          <tr>
            <th>Company</th>
            { /* Financiers table does not have this column. */
              this.props.sectorCode !== 'f' ?
                <th>Deforestation risk commodities</th> :
                null
            }
            <th>Research links</th>
          </tr>
        </thead>
        <tbody>
          {
            this.props.companies.map(company => {
              // get flags and links
              const company_flags = this.getCompanyFlags(company, icons)
              const company_links = this.getCompanyLinks(company)

              // console.log(company)
              // company_id: "0C00000CEM"
              // is_po_consumer: true
              // is_po_financier: null
              // is_po_producer: true
              // legal_name: "Stora Enso Oyj"
              // primary_symbol: "STERV"
              // short_name: "Stora Enso"
              // version: "120"
              return <tr>
                <td data-label='Company'>
                  <CompanyProfileModal company_id={company.company_id}>
                    <span styleName='screened-companies-list__company-title'>
                      { company.short_name }
                    </span>
                  </CompanyProfileModal>
                  <br/>
                  <span styleName='screened-companies-list__subtitle'>
                    { 
                      company.primary_symbol ?
                        <span>
                          [{company.primary_symbol}]
                        </span> :
                        null
                    }
                    &nbsp;
                    {
                      company.legal_name ?
                        company.legal_name :
                        null
                    }
                  </span>
                </td>
                { /* Financiers table does not have this column. */
                  this.props.sectorCode !== 'f' ?
                    <td data-label='Commodities'>
                      {
                        company_flags.length > 0 ?
                          company_flags.map(flag => {
                            return <img
                              styleName='screened-companies-list__icon'
                              key={flag[0]}
                              src={flag[1]}
                              alt={flag[2]}
                              title={flag[2]}
                            />
                          }) :
                          null
                      }
                    </td> :
                    null
                }            
                <td data-label='Research links'>
                  { /* display any research links for the company  */
                    company_links.map((e, i) => {
                      return e[0].length ?
                        <div key={i} styleName='research-link-div'>
                          <Link
                            to={e[0]}
                            title={e[1]+': ' + company.short_name}
                            xstrong
                          >
                            {e[1]}
                          </Link>
                        </div> :
                        null
                    })
                  }
                </td>
              </tr>
            })
          }
        </tbody>
      </table>
    </div>
  }
}
